import React from "react";
import { useNavigate, useParams } from "react-router";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "../schemes/components/Breadcrumb/Breadcrumb";
import Sidebar from "../schemes/components/Sidebar/Sidebar";
import RtiContent from "./components/RtiContent/RtiContent";
import rtiMenuItems, {
  getRtiMenuSectionId,
  getRtiSection,
  normalizeRtiSection,
} from "./data/rtiMenuItems";

const PageTitle = ({ label }) => {
  const title = label;

  return (
    <h1 className="m-0 text-[20px] font-bold leading-[1.2] uppercase tracking-[1px] text-[#1b3a6b] md:text-[23px] first-letter:text-[#ff9933]">
      {title}
    </h1>
  );
};

const RightToInformationPage = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const activeSection = normalizeRtiSection(section);
  const activeMenuSection = getRtiMenuSectionId(activeSection);

  useFocusPageStart(section || activeSection);

  const handleSelectSection = (sectionId) => {
    navigate(`/right-to-information/${sectionId}`);
  };

  const currentSection = getRtiSection(activeSection);
  const parentSection = currentSection.parentId
    ? getRtiSection(currentSection.parentId)
    : null;

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Right to Information", path: "/right-to-information" },
    ...(parentSection
      ? [
          {
            label: parentSection.label,
            path: parentSection.path,
          },
        ]
      : []),
    {
      label: currentSection.label,
      path: `/right-to-information/${activeSection}`,
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-4 pt-2 pb-3 md:px-20 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 pb-[180px] outline-none md:pb-[200px]"
      >
        <div className="px-4 pt-7 pb-3.5 md:px-20 md:pb-[18px]">
          <PageTitle label={parentSection?.label || currentSection.label} />
        </div>

        <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-5 p-5 md:p-10 lg:flex-row lg:gap-[30px]">
          <Sidebar
            activeSection={activeMenuSection}
            onSelectSection={handleSelectSection}
            menuItems={rtiMenuItems}
          />
          <RtiContent activeSection={activeSection} />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RightToInformationPage;
